module.exports = __webpack_public_path__ + "static/before-1-ebad817286ef67ea8147ffb9d7c27ee2.png";